module.exports = __webpack_public_path__ + "static/media/company_profile.73fc693.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_profile.mp4
// module id = yuaO
// module chunks = 1